import React from 'react'
import List from './components/StaffPickList'

const Route = () => ({
  index: true,
  path: '',
  element: <List />,
})

export default Route
